var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import '@styles/webdesktop/stylesheets/comboboxDropdownItem.scss';
import { Background, BorderSize, Foreground } from '@front/sharedcomponents/Styles';
export const ComboboxDropdownItemDecorator = (_a) => {
    var { isSelected = false, isHighlightSelection = true, children, onClick } = _a, restProps = __rest(_a, ["isSelected", "isHighlightSelection", "children", "onClick"]);
    const isSelectedAndHighlighted = isSelected && isHighlightSelection;
    const dropdownItemClassNames = [
        'combobox-dropdown-item',
        isSelectedAndHighlighted ? Background.Primary : Background.Secondary,
        isSelectedAndHighlighted ? Foreground.Primary : Foreground.Secondary,
        BorderSize.None
    ];
    const dropdownItemClassName = dropdownItemClassNames.filter(Boolean).join(' ');
    return (_jsx("div", Object.assign({ className: dropdownItemClassName, role: "option", tabIndex: 0, "aria-selected": isSelected, onClick: onClick, onKeyDown: (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick();
            }
        } }, restProps, { children: children })));
};
